// extracted by mini-css-extract-plugin
export default {"formField":"Fqa-z","error":"Gqa-z","disabled":"Hqa-z","fieldError":"Iqa-z","errorText":"Jqa-z","button":"Kqa-z","acknowledgment":"Lqa-z"};